module.exports = __webpack_public_path__ + "img/GAME_BLOCKFLIP1.800e567b.jpg";